import React, { Component } from "react";
import { getBaseURL } from "components/helpers/HostURLHelper.jsx";
import { withStyles } from "@material-ui/core/styles";
import ComboBox from "../core/ComboBox.jsx";
import { formatDateWithoutTime } from "components/helpers/DateTimeHelper.jsx";
import qs from "query-string";

const styles = (theme) => ({});

class AnalystTestsLOV extends Component {
  state = {
    selectedTestPaper: "",
    allSchedules: [],
    selectedTestPaperOption: null,
  };

  componentDidMount() {
    const paper_id = qs.parse(this?.props?.location?.search)?.paper_id;
    this.setState({ selectedTestPaper: paper_id }, this.fetchSchedules);
  }

  componentDidUpdate(prevProps) {
    const { program_id, test_type_id } = this.props;

    if (
      prevProps.program_id !== program_id ||
      prevProps.test_type_id !== test_type_id
    ) {
      this.fetchSchedules(); // custom method to fetch + process
    }
  }

  fetchSchedules = () => {
    const { program_id, test_type_id } = this.props;
    let url = getBaseURL() + "/analysis/schedules.json";

    const params = new URLSearchParams();
    if (program_id) params.append("program_id", program_id);
    if (test_type_id) params.append("test_type_id", test_type_id);

    const fullUrl = url + "?" + params.toString();

    $.ajax({
      type: "GET",
      url: fullUrl,
    })
      .done((data) => {
        this.processSchedulesData(data);
      })
      .fail(() => {
        // TODO: handle error
      });
  };

  processSchedulesData(data) {
    const schedules = data["schedules"];
    const allSchedules = [];
    const paper_id = qs.parse(this?.props?.location?.search)?.paper_id;
    let selectedTestPaperOption = null;

    if (schedules) {
      for (let schedule of schedules) {
        const papers = schedule.sch_papers || [];
        const multiplePapers = papers.length > 1;

        for (let paper of papers) {
          const paperLabel = multiplePapers
            ? `${schedule.name} - Paper ${paper.paper_no}`
            : `${schedule.name}`;

          const paperOption = {
            name: paperLabel,
            paper_id: paper.id,
            start_time: formatDateWithoutTime(paper.start_time),
          };

          allSchedules.push(paperOption);

          if (paper_id && paper.id == paper_id) {
            selectedTestPaperOption = paperOption;
          }
        }
      }

      this.setState({
        allSchedules,
        selectedTestPaperOption,
      });
    }
  }

  onSelectSchedule = (event, option) => {
    this.setState({
      selectedTestPaper: option.paper_id,
      selectedTestPaperOption: option,
    });
    this.props.onSelectSchedule(option);
  };

  allSchedulesOptionLabel = (option) =>
    option.name + " (" + option.start_time + ")";

  render() {
    const { allSchedules, selectedTestPaperOption } = this.state;
    return (
      <React.Fragment>
        <ComboBox
          variant="controlled"
          value={selectedTestPaperOption}
          optionLabel={this.allSchedulesOptionLabel}
          options={allSchedules}
          onChange={this.onSelectSchedule}
          label={"Select Test"}
        />
      </React.Fragment>
    );
  }
}

export default withStyles(styles)(AnalystTestsLOV);
